export default __webpack_public_path__ + "static/media/about_logo.afca3c9f.svg";